import * as R from 'ramda';
import { createSelector } from 'reselect';

import {
  getDataFromState,
  getDataFromStateAndProps,
} from './common';

import { getUsers } from './users';


const getTasksFilters = state => state.tasks.filters;
const getIsAllTasks = (_, props) => R.propOr(false, 'isAllTasks', props);


export const getTasks = createSelector(
  [getDataFromStateAndProps('tasks'), getUsers],
  (tasks, users) =>
    Object.keys(tasks).map(key => ({
      ...tasks[key],
      assignedTo: users[tasks[key].assignedTo] || {},
    })),
);

export const getMyOrFilteredTasks = createSelector(
  [
    getDataFromState('tasks'),
    getUsers,
    getTasksFilters,
    getIsAllTasks,
  ],
  (tasks, users, filters, isAllTasks = false) => {
    let isFilter = false;
    Object.keys(filters).forEach((filterKey) => {
      isFilter = filters[filterKey].length !== 0 || isFilter;
    });

    const myId = localStorage.getItem('userId');
    return Object.keys(tasks).reduce((accum, key) => {
      const task = tasks[key];
      if (isAllTasks) {
        return (isFilter || !isFilter && task.assignedTo === myId)
          ? accum.concat({ ...task, assignedTo: users[task.assignedTo] || {} })
          : accum;
      }

      // tasks by assignee
      if (isFilter && !task.status) {
        return filters.assignee.includes(task.assignedTo) || !task.assignedTo
          ? accum.concat({ ...task, assignedTo: users[task.assignedTo] || {} })
          : accum;
      }

      // own tasks
      return (!isFilter && task.assignedTo === myId) && !task.status
        ? accum.concat({ ...task, assignedTo: users[task.assignedTo] || {} })
        : accum;
    }, []);
  },
);

export const getCompletedTasks = createSelector(
  [getDataFromState('tasks'), getUsers],
  (tasks, users) => Object.keys(tasks).reduce((accum, key) => {
    const task = tasks[key];
    return task.status && task.completedAt
      ? accum.concat({ ...task, assignedTo: users[task.assignedTo] || {} })
      : accum;
  }, []),
);



// WEBPACK FOOTER //
// ./src/redux/selectors/tasks.js